"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _MetricsTableStyles = require("web/shared/telemetry/overview/MetricsTable.styles.js");
var _perfTablesStyles = require("web/shared/telemetry/perfTables.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A column heading that sorts the table by its column when clicked, marking
* itself with the direction when it is the one being sorted by.
*/
function SortableHeader(_ref) {
  let label = _ref.label,
    column = _ref.column,
    activeColumn = _ref.activeColumn,
    descending = _ref.descending,
    onSort = _ref.onSort,
    numeric = _ref.numeric;
  const isActive = column === activeColumn;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(numeric ? _perfTablesStyles.styles.numericHeadCell : _perfTablesStyles.styles.headCell, _perfTablesStyles.styles.dividedCell, _MetricsTableStyles.styles.sortableHeader)), {}, {
    onClick: () => onSort(column),
    title: "Sort by ".concat(label) // The direction belongs on the cell, where a screen reader announces it
    // with the column; the arrow beside the label then draws it for everyone
    // else and says nothing of its own.
    ,
    "aria-sort": isActive ? descending ? "descending" : "ascending" : "none",
    children: [label, isActive ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [" ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_MetricsTableStyles.styles.sortMarker)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          name: descending ? "arrow-down" : "arrow-up",
          size: "xs"
        })
      }))]
    }) : null]
  }));
}
var _default = exports.default = SortableHeader;